<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-8"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Provedor</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>

        <form @submit.prevent="onSubmit(form)">


            <Tabs v-model:value="tabIndex">
                <TabList>
                    <Tab :value="0">Provedor</Tab>
                    <Tab :value="1" :disabled="!form.id">Contratos</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel :value="0">
                        <ScrollPanel style="height: 60vh">
                            <div class="w-full">
                                <div class="field mt-4">
                                    <FloatLabel>
                                        <InputText id="nome" v-model="form.nome" class="w-full" />
                                        <label for="nome">Nome<span class="text-red-500">*</span></label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['nome'] }}</div>
                                </div>

                                <div class="field mt-4">
                                    <FloatLabel>
                                        <InputText id="documento" v-model="form.documento" class="w-full" />
                                        <label for="documento">CPF/CNPJ</label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['documento'] }}</div>
                                </div>
                                <div class="flex gap-2">
                                    <div class="field mt-4 w-6">
                                        <FloatLabel>
                                            <InputText id="telefone1" v-model="form.telefone1" class="w-full" />
                                            <label for="telefone1">Telefone 1</label>
                                        </FloatLabel>
                                        <div class="text-xs text-red-500">{{ errors['telefone1'] }}</div>
                                    </div>
                                    <div class="field mt-4 w-6">
                                        <FloatLabel>
                                            <InputText id="telefone2" v-model="form.telefone2" class="w-full" />
                                            <label for="telefone2">Telefone 2</label>
                                        </FloatLabel>
                                        <div class="text-xs text-red-500">{{ errors['telefone2'] }}</div>
                                    </div>
                                </div>
                                <div class="field mt-4">
                                    <FloatLabel>
                                        <InputText id="email" v-model="form.email" class="w-full" />
                                        <label for="email">Email</label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['email'] }}</div>
                                </div>

                                <div class="field mt-4">
                                    <FloatLabel>
                                        <InputText id="central" v-model="form.central" class="w-full" />
                                        <label for="central">Central</label>
                                    </FloatLabel>
                                    <div class="text-xs text-red-500">{{ errors['central'] }}</div>
                                </div>

                                <div class="flex gap-2">
                                    <div class="field mt-4 w-4">
                                        <FloatLabel>
                                            <InputText id="contato" v-model="form.contato" class="w-full" />
                                            <label for="contato">Contato</label>
                                        </FloatLabel>
                                        <div class="text-xs text-red-500">{{ errors['contato'] }}</div>
                                    </div>
        
                                    <div class="field mt-4 w-4">
                                        <FloatLabel>
                                            <InputText id="contato_telefone" v-model="form.contato_telefone" class="w-full" />
                                            <label for="contato_telefone">Contato Telefone</label>
                                        </FloatLabel>
                                        <div class="text-xs text-red-500">{{ errors['contato_telefone'] }}</div>
                                    </div>
        
                                    <div class="field mt-4 w-4">
                                        <FloatLabel>
                                            <InputText id="contato_email" v-model="form.contato_email" class="w-full" />
                                            <label for="contato_email">Contato E-mail</label>
                                        </FloatLabel>
                                        <div class="text-xs text-red-500">{{ errors['contato_email'] }}</div>
                                    </div>
                                </div>
                            </div>
                        </ScrollPanel>

                    </TabPanel>

                    <TabPanel :value="1">
                        <ScrollPanel style="height: 60vh">
                            <FormTabContratos v-if="form.id" :provedor="form" @onOpenContratoForm="openForm" ></FormTabContratos>
                        </ScrollPanel>

                    </TabPanel>
                </TabPanels>

            </Tabs>

            <div class="flex justify-content-end gap-1">
                <Button type="submit" label="Salvar" severity="success" icon="pi pi-save" size="small"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" :loading="isLoading" />
            </div>
        </form>

        <LogForm :visible="visibleLogForm" table="provedores" :tableId="form.id" @close="visibleLogForm=false" />

    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Badge from 'primevue/badge';
import Fluid from 'primevue/fluid';

import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import ScrollPanel from 'primevue/scrollpanel';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

import DataTable from 'primevue/datatable';
import Toolbar from 'primevue/toolbar';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';

import Popover from 'primevue/popover';

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Provedor from '@/service/provedor.js';
import Contrato from '@/service/contrato.js';

import LogForm from '@/components/LogForm.vue';
import FormTabContratos from '@/page/provedor/FormTabContratos.vue';

import Filter from '@/utils/Filter.js';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        DataTable,
        Paginator,
        Column,
        InputMask,
        Select,
        AutoComplete,
        Checkbox,
        ScrollPanel,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        InputGroup,
        InputGroupAddon,
        Toolbar,
        Badge,
        Popover,
        Fluid,

        LogForm,
        FormTabContratos,
    },
    props: {
        visible: false,
        data: {},
    },
    emits: ['save', 'close', 'onOpenContratoForm'],
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,

            visibleLogForm: false,

            tabIndex: 0,
        }
    },
    methods: {
        openForm(contrato) {
            this.$emit("onOpenContratoForm", contrato);
        },
        onShow() {
            this.errors = {};
            this.form = Provedor.parse({ ...(this.data || {}) });
        },
        onHide() {
            this.form = {};
            this.tabIndex = 0;
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if (form.id) {
                return Provedor.update(form.id, form);
            }
            return Provedor.create(form);
        },
        onSubmit(form) {
            this.errors = {};
            this.isLoading = true;

            this.save(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });
                    this.form = Provedor.parse(response.data.data);
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if (error.response) {
                        let err = error.response.data;
                        if (err.erros) {
                            for (let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
}
</script>
